class Carousel {
	constructor(container, options = {}) {
		this.container = container;
		this.options = {
			slideWidth: 315,
			swipeThreshold: 50,
			animationDuration: 300,
			...options,
		};

		this.currentSlide = 0;
		this.slideCount = this.container.find(".slider-slide").length;
		this.touchStartX = 0;
		this.isDragging = false;
		this.startTranslate = 0;
		this.isAnimating = false;
		this.$wrapper = this.container.find(".slider-wrapper");

		this.setupStyles();
		this.setupEventListeners();
		this.updateSlider(true);
	}

	setupStyles() {
		this.$wrapper.css({
			transition: `transform ${this.options.animationDuration}ms ease-out`,
			"will-change": "transform",
			transform: "translate3d(0, 0, 0)",
			"touch-action": "pan-y pinch-zoom",
		});
	}

	setupEventListeners() {
		this.setupNavigationButtonHandlers();
		this.setupTouchHandlers();
		this.setupResizeHandler();
		//this.setupWheelHandler(); // Add wheel event setup
	}

	setupNavigationButtonHandlers() {
		this.container
			.find(".slider-button-next-carousel")
			.on("click", this.handleNextClick.bind(this));
		this.container
			.find(".slider-button-prev-carousel")
			.on("click", this.handlePrevClick.bind(this));
	}

	setupTouchHandlers() {
		this.$wrapper
			.on("pointerdown", this.handlePointerDown.bind(this))
			.on("pointermove", this.handlePointerMove.bind(this))
			.on("pointerup pointercancel", this.handlePointerUp.bind(this))
			.on("touchstart", this.handleTouchStart.bind(this))
			.on("touchmove", this.handleTouchMove.bind(this))
			.on("touchend touchcancel", this.handleTouchEnd.bind(this));

		this.$wrapper.on("transitionend", this.handleTransitionEnd.bind(this));
	}

	setupResizeHandler() {
		$(window).on("resize", this.handleResize.bind(this));
	}

	handleNextClick() {
		if (this.isAnimating || this.currentSlide >= this.slideCount - 1)
			return;
		this.currentSlide++;
		this.updateSlider();
	}

	handlePrevClick() {
		if (this.isAnimating || this.currentSlide <= 0) return;
		this.currentSlide--;
		this.updateSlider();
	}

	handlePointerDown(e) {
		if (this.isAnimating) return;

		this.isDragging = true;
		this.touchStartX = e.originalEvent.pageX;
		this.startTranslate = this.getCurrentTranslate(this.$wrapper);

		this.$wrapper.css("transition", "none");
		this.$wrapper[0].setPointerCapture(e.originalEvent.pointerId);
	}

	handlePointerMove(e) {
		if (!this.isDragging) return;

		const currentX = e.originalEvent.pageX;
		const diff = currentX - this.touchStartX;
		const newTranslate = this.startTranslate + diff;

		// Apply edge resistance
		if (this.currentSlide === 0 && diff > 0) {
			this.$wrapper.css(
				"transform",
				`translate3d(${diff * 0.3}px, 0, 0)`
			);
		} else if (this.currentSlide === this.slideCount - 1 && diff < 0) {
			this.$wrapper.css(
				"transform",
				`translate3d(${this.startTranslate + diff * 0.3}px, 0, 0)`
			);
		} else {
			this.$wrapper.css(
				"transform",
				`translate3d(${newTranslate}px, 0, 0)`
			);
		}
	}

	handlePointerUp(e) {
		if (!this.isDragging) return;

		this.isDragging = false;
		const currentX = e.originalEvent.pageX;
		const diff = currentX - this.touchStartX;

		this.$wrapper[0].releasePointerCapture(e.originalEvent.pointerId);
		this.$wrapper.css(
			"transition",
			`transform ${this.options.animationDuration}ms ease-out`
		);

		this.snapToClosestSlide(diff);
	}

	handleTouchStart(e) {
		if (this.isAnimating) return;

		this.isDragging = true;
		this.touchStartX = e.originalEvent.touches[0].pageX;
		this.startTranslate = this.getCurrentTranslate(this.$wrapper);
		this.$wrapper.css("transition", "none");
	}

	handleTouchMove(e) {
		if (!this.isDragging) return;

		const currentX = e.originalEvent.touches[0].pageX;
		const diff = currentX - this.touchStartX;
		const newTranslate = this.startTranslate + diff;

		if (this.currentSlide === 0 && diff > 0) {
			this.$wrapper.css(
				"transform",
				`translate3d(${diff * 0.3}px, 0, 0)`
			);
		} else if (this.currentSlide === this.slideCount - 1 && diff < 0) {
			this.$wrapper.css(
				"transform",
				`translate3d(${this.startTranslate + diff * 0.3}px, 0, 0)`
			);
		} else {
			this.$wrapper.css(
				"transform",
				`translate3d(${newTranslate}px, 0, 0)`
			);
		}
	}

	handleTouchEnd(e) {
		if (!this.isDragging) return;

		this.isDragging = false;
		const currentX = e.originalEvent.changedTouches[0].pageX;
		const diff = currentX - this.touchStartX;

		this.$wrapper.css(
			"transition",
			`transform ${this.options.animationDuration}ms ease-out`
		);

		this.snapToClosestSlide(diff);
	}

	snapToClosestSlide(diff) {
		// Determine the slide index based on swipe distance
		const swipeDistanceInSlides = Math.round(
			diff / this.options.slideWidth
		);
		const newSlide = this.currentSlide - swipeDistanceInSlides;

		// Ensure the new slide index is within bounds
		this.currentSlide = Math.max(
			0,
			Math.min(newSlide, this.slideCount - 1)
		);

		// Move to the calculated slide
		this.updateSlider();
	}

	handleTransitionEnd() {
		this.isAnimating = false;
	}

	handleResize() {
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(() => this.updateSlider(true), 150);
	}

	setupWheelHandler() {
		this.container.on("wheel", this.handleWheelScroll.bind(this));
	}

	handleWheelScroll(e) {
		// Only handle horizontal scrolls to avoid hijacking vertical scrolls
		const horizontalThreshold = 20;

		// Ignore if the vertical scroll is more significant than the horizontal
		if (
			Math.abs(e.originalEvent.deltaX) < horizontalThreshold ||
			Math.abs(e.originalEvent.deltaY) > Math.abs(e.originalEvent.deltaX)
		) {
			return;
		}

		// Prevent default horizontal scroll only if we're handling it
		e.preventDefault();

		// Debounce to prevent excessive slide changes with fast scrolls
		if (this.isAnimating) return;

		// Determine scroll direction based on deltaX value
		if (e.originalEvent.deltaX > 0) {
			this.handleNextClick();
		} else if (e.originalEvent.deltaX < 0) {
			this.handlePrevClick();
		}
	}

	updateSlider(immediate = false) {
		if (this.isAnimating && !immediate) return;

		const offset = -this.currentSlide * this.options.slideWidth;
		this.isAnimating = true;

		if (immediate) {
			this.$wrapper.css({
				transition: "none",
				transform: `translate3d(${offset}px, 0, 0)`,
			});
			this.$wrapper[0].offsetHeight;
			this.$wrapper.css(
				"transition",
				`transform ${this.options.animationDuration}ms ease-out`
			);
			this.isAnimating = false;
		} else {
			this.$wrapper.css("transform", `translate3d(${offset}px, 0, 0)`);
			setTimeout(() => {
				this.isAnimating = false;
			}, this.options.animationDuration);
		}

		this.container
			.find(".slider-button-prev-carousel")
			.toggleClass("active", this.currentSlide > 0);
		this.container
			.find(".slider-button-next-carousel")
			.toggleClass("active", this.currentSlide < this.slideCount - 1);
	}

	getCurrentTranslate($element) {
		const transform = $element.css("transform");
		if (transform === "none") return 0;
		const matrix = transform.match(/matrix.*\((.*)\)/)[1].split(",");
		return parseInt(matrix[4], 10);
	}
}

// Initialize carousels
jQuery(($) => {
	$(".bottom.slider-carousel, .top.slider-carousel").each((_, el) => {
		new Carousel($(el));
	});
});
